 // @version V0.0.1 [Wednesday - 20201028_093808] : init
let DefaultPage = () => import('@/asahi/page-layout/DefaultPage')
// let DeleteConfirmation = () => import('@vue-libraries/Bootstrap4/template/DeleteConfirmation')
let CostForm = () => import('@/asahi/cost/CostForm')
let CategoryForm = () => import('@/asahi/category/CategoryForm')
let CategoryClassForm = () => import('@/asahi/category-class/CategoryClassForm')
let BillingCustomerTemplateLetterForm = () => import('@/asahi/billing-customer/BillingCustomerTemplateLetterForm')

export default  ([
    {
        path: '/',
        alias: '/welcome',
        name: 'welcome',
        component: () => import('@/asahi/childs/WelcomeDisplay')
 
    },
    {
        path: '/version-info',
        name: 'version-info',
        component: () => import('@/asahi/VersionInfo')
    },
    {
        path: '/user-login',
        name: 'user-login',
        component: () => import('@/asahi/template/auth/vuex/Login')
    },
    //{
        //path: '/user-register',
        //name: 'user-register',
        //component: () => import('@/asahi/template/auth/vuex/Register')
    //},
    // ------------------------------------- //
    {
        path: '/customer',
        name: 'customer-list',
        redirect: { name: 'customer-default' },
        component: () => import('@/asahi/customer/CustomerIndex'),
        children: [
            {
                path: 'default',
                name: 'customer-default',
                component: DefaultPage
            },
            { 
                path: 'new',
                name: 'customer-new',
                component: () => import('@/asahi/customer/CustomerNew')
            },
            {
                path: 'edit',
                name: 'customer-edit',
                component: () => import('@/asahi/customer/CustomerEdit')
            }
        ]
    },
    /**
     * ASSET
     */
    //-> asset
    {
        path: '/asset',
        name: 'asset',
        component: () => import ('@/asahi/asset/AssetPage'),
        redirect: { name : 'asset-list'},
        children: [
            {
                path: 'list',
                name: 'asset-list',
                component: () => import ('@/asahi/asset/AssetIndex'),
            },
            {
                path: 'purchase',
                name: 'asset-purchase',
                component: () => import ('@/asahi/asset/AssetPurchase')
            },
            {
                path: 'purchase/edit',
                name : 'asset-purchase-edit',
                component: () => import ('@/asahi/asset/AssetPurchaseEdit')
            },
        ]
    },
    /**
     * SETTING
     */
    //-> account
    {
        path: '/setting/account',
        name: 'account',
        redirect: { name : 'account-list'},
        component: () => import ('@/asahi/account/AccountPage'),
        children: [
            {
                path: 'list',
                name: 'account-list',
                component: () => import ('@/asahi/account/AccountIndex'),
            },
            {
                path: 'new',
                name: 'account-new',
                component: () => import ('@/asahi/account/AccountNew')
            },
            {
                path: 'edit',
                name : 'account-edit',
                component: () => import ('@/asahi/account/AccountEdit')
            },
        ]
    },
    //-> account sync
    {
        path: '/setting/account-sync',
        name: 'account-sync',
        component: () => import ('@/asahi/account-sync/AccountSyncIndex'),
    },
    //-> authorization
    {
        path: '/setting/authorization',
        name: 'authorization',
        component: () => import('@/asahi/authorization/AuthorizationPage'),
        children : [
            {
                path: 'page-role',
                name: 'authorization-page-role',
                component: () => import('@/asahi/authorization/PageRole')
            },
            {
                path: 'role',
                name: 'authorization-role',
                component: () => import('@/asahi/authorization/Role')
            },
            {
                path: 'action-role',
                name: 'authorization-action-role',
                component: () => import('@/asahi/authorization/ActionRole')
            }
        ]
    },
    //-> general setting
    {
        path: '/setting/general-setting',
        name: 'general-setting',
        component: () => import('@/asahi/general-setting/GeneralSettingForm')
    },
    //--> product
    {
        path: '/setting/product',
        name: 'product',
        //redirect: { name : 'product-list' },
        component: () => import('@/asahi/product/ProductPage'),
        children : [
            {
                path : 'list',
                name: 'product-list',
                component: () => import('@/asahi/product/ProductIndex')
            },
            {
                path: 'new',
                name: 'product-new',
                component: () => import ('@/asahi/product/ProductNew')
            },
            {
                path: 'edit',
                name: 'product-edit',
                component: () => import ('@/asahi/product/ProductEdit')
            },
            {
                path: 'product-category/new',
                name : 'product-category-new',
                component: CategoryForm,
                props: { relatedTable : 'products', editMode : false, showGroup : true }
            },
            {
                path: 'product-category/edit',
                name : 'product-category-edit',
                component: CategoryForm,
                props: { relatedTable : 'products', editMode : true, showGroup : true }
            },
            {
                path: 'product-category/list',
                name :'product-category-list',
                component: () => import('@/asahi/category/CategoryList'),
                props: { relatedTable : 'products', showGroup : true}
            },
            {
                path: 'product-category-class/new',
                name : 'product-category-class-new',
                component: CategoryClassForm,
                props: { relatedTable : 'products', editMode : false }
            },
            {
                path: 'product-category-class/edit',
                name : 'product-category-class-edit',
                component: CategoryClassForm,
                props: { relatedTable : 'products', editMode : true }
            },
            {
                path: 'product-category-class/list',
                name :'product-category-class-list',
                component: () => import('@/asahi/category-class/CategoryClassList'),
                props: { relatedTable : 'products'}
            },
        ]
    },
    //-> supplier
    {
        path: '/supplier',
        name: 'supplier',
        redirect: { name: 'supplier-list'},
        component: () => import('@/asahi/supplier/SupplierPage'),
        children : [
            {
                path : 'list',
                name: 'supplier-list',
                component: () => import('@/asahi/supplier/SupplierIndex'),
            },
            {
                path: 'new',
                name: 'supplier-new',
                component: () => import('@/asahi/supplier/SupplierNew')
            },
            {
                path: 'edit',
                name: 'supplier-edit',
                component: () => import('@/asahi/supplier/SupplierEdit')
            },
        ]
    },
    //--> user
    {
        path: '/setting/user',
        name: 'user',
        redirect: { name: 'user-list'},
        component: () => import('@/asahi/user/UserPage'),
        children : [
            {
                path : 'list',
                name: 'user-list',
                component: () => import('@/asahi/user/UserIndex')
            },
            {
                path: 'new',
                name: 'user-new',
                component: () => import('@/asahi/user/UserNew')
            },
            {
                path: 'edit',
                name: 'user-edit',
                component: () => import('@/asahi/user/UserEdit')
            },
        ]
    },
    //-> user cash
    {
        path: '/setting/user-cash',
        name: 'user-cash',
        redirect: { name: 'user-cash-list'},
        component: () => import('@/asahi/user-cash/UserCashPage'),
        children: [
            {
                path: 'list',
                name: 'user-cash-list',
                component: () => import('@/asahi/user-cash/UserCashIndex')
            },
            {
                path: 'new',
                name: 'user-cash-new',
                component: () => import('@/asahi/user-cash/UserCashNew')
            },
            {
                path: 'edit',
                name: 'user-cash-edit',
                component: () => import('@/asahi/user-cash/UserCashEdit')
            },
        ]
    },
    //-> unit
    {
        path: '/setting/unit',
        name: 'unit',
        redirect: { name: 'unit-list'},
        component: () => import('@/asahi/unit/UnitPage'),
        children : [
            {
                path : 'list',
                name: 'unit-list',
                component: () => import('@/asahi/unit/UnitIndex'),
            },
            {
                path: 'new',
                name: 'unit-new',
                component: () => import('@/asahi/unit/UnitNew')
            },
            {
                path: 'edit',
                name: 'unit-edit',
                component: () => import('@/asahi/unit/UnitEdit')
            },
        ]
    },
    //-> warehouse
    {
        path: '/setting/warehouse',
        name: 'warehouse',
        redirect: { name: 'warehouse-list'},
        component: () => import('@/asahi/warehouse/WarehousePage'),
        children : [
            {
                path : 'list',
                name: 'warehouse-list',
                component: () => import('@/asahi/warehouse/WarehouseIndex'),
            },
            {
                path: 'new',
                name: 'warehouse-new',
                component: () => import('@/asahi/warehouse/WarehouseNew')
            },
            {
                path: 'edit',
                name: 'warehouse-edit',
                component: () => import('@/asahi/warehouse/WarehouseEdit')
            },
        ]
    },
    /**
     * TRANSACTION
     */
    {
        name : 'purchase',
        path: '/transaction/purchase',
        component: () => import('@/asahi/purchase/PurchasePage'),
        children: [
            {
                path: 'form',
                name: 'purchase-form',
                component: () => import('@/asahi/purchase/PurchaseForm')
            },
            {
                path: 'read',
                name: 'purchase-detail',
                component: () => import('@/asahi/purchase/PurchaseRead')
            },
            {
                path: 'payments',
                name : 'purchase-payments-form',
                component: () => import('@/asahi/purchase-payment/PurchasePaymentsForm'),
            }
        ]
    },
    {
        path: '/transaction/purchase-return',
        name: 'purchase-return',
        component: () => import('@/asahi/purchase-return/PurchaseReturnPage'),
        children: [
            {
                path: 'form',
                name: 'purchase-return-form',
                component: () => import('@/asahi/purchase-return/PurchaseReturnForm')
            }
        ]
    },
    //=> sale
    {
        path : '/transaction/sale',
        name : 'sale',
        component: () => import('@/asahi/sale/SalePage'),
        children : [
            {
                path: 'form',
                name : 'sale-form',
                component: () => import('@/asahi/sale/SaleForm'),
                
            },
            {
                path: 'receipt',
                name : 'sale-receipt',
                component: () => import('@/asahi/sale/SaleReceipt'),
            },
            {
                path: 'invoice',
                name : 'sale-invoice',
                component: () => import('@/asahi/sale/SaleInvoice'),
                props: true
            },
            {
                path: 'read',
                name : 'sale-detail',
                component: () => import('@/asahi/sale/SaleRead'),
            },
            {
                path: 'payments',
                name : 'sale-payments-form',
                component: () => import('@/asahi/sale-payment/SalePaymentsForm'),
            }
        ]
    },
    {
        path: '/transaction/sale-return',
        name: 'sale-return',
        component: () => import('@/asahi/sale-return/SaleReturnPage'),
        children: [
            {
                path: 'form',
                name: 'sale-return-form',
                component: () => import('@/asahi/sale-return/SaleReturnForm')
            }
        ]
    },
    {
        path: '/transaction/billing-customer',
        name: 'billing-customer',
        component: () => import('@/asahi/billing-customer/BillingCustomerPage'),
        children: [
            {
                path: 'template',
                name: 'billing-customer-template-letter',
                component: () => import('@/asahi/billing-customer/BillingCustomerTemplateLetterIndex'),
                children: [
                    {
                        path: 'new',
                        name: 'billing-customer-template-letter-new',
                        component: BillingCustomerTemplateLetterForm,
                        props: { editMode : false }
                    },
                    {
                        path: 'edit',
                        name: 'billing-customer-template-letter-edit',
                        component: BillingCustomerTemplateLetterForm,
                        props: { editMode : true }
                    },
                    {
                        path: 'read',
                        name: 'billing-customer-template-letter-read',
                        component: () => import('@/asahi/billing-customer/BillingCustomerTemplateLetterRead'),
                    },
                ]
            },
            {
                path: 'publish',
                name: 'billing-customer-publish-letter',
                component: () => import('@/asahi/billing-customer/BillingCustomerPublishLetterIndex')
            }
        ]
    },
    {
        path: '/transaction/cost',
        name: 'cost',
        //redirect: { name: 'cost-list' },
        component: () => import('@/asahi/cost/CostPage'),
        children: [
            {
                path : 'list',
                name: 'cost-list',
                component: () => import('@/asahi/cost/CostIndex')
            },
            {
                path : 'new',
                name: 'cost-new',
                component: CostForm,
                props: { editMode : false }
            },
            {
                path : 'edit',
                name: 'cost-edit',
                component: CostForm,
                props: { editMode : true }
            },
            {
                path: 'cost-category/new',
                name : 'cost-category-new',
                component: CategoryForm,
                props: { relatedTable : 'costs', editMode : false }
            },
            {
                path: 'cost-category/edit',
                name : 'cost-category-edit',
                component: CategoryForm,
                props: { relatedTable : 'costs', editMode : true }
            },
            {
                path: 'cost-category/list',
                name :'cost-category-list',
                component: () => import('@/asahi/category/CategoryList'),
                props: { relatedTable : 'costs'}
            },

        ]
    },
    /**
     * STOCK
     */
    {
        path: '/stock',
        name: 'stock',
        component: () => import('@/asahi/stock/StockPage'),
        children: [
            {
                name: 'stock-recap',
                path: 'stock-recap',
                component: () => import('@/asahi/stock/StockRecapIndex')
            },
            {
                name: 'stock-warehouse',
                path: 'stock-warehouse',
                component: () => import('@/asahi/stock/StockWarehouseIndex')
            },
            {
                name: 'stock-mutation',
                path: 'stock-mutation',
                component: () => import('@/asahi/stock/StockMutationIndex')
            },
            {
                name: 'stock-delivery',
                path: 'stock-delivery',
                component: () => import('@/asahi/stock/StockDeliveryIndex'),
                children: [
                    {
                        name: 'stock-delivery-form',
                        path: 'form',
                        component: () => import('@/asahi/stock/StockDeliveryForm')
                    },
                    {
                        path: 'undelivered',
                        name: 'stock-delivery-undelivered',
                        component: () => import('@/asahi/stock/StockDeliveryUndelivered')
                    }
                ]
            },
            {
                path: 'stock-transfer',
                name: 'stock-transfer',
                component: () => import ('@/asahi/stock/StockTransferIndex')
            },
            {
                path: 'stock-audit',
                name: 'stock-audit',
                component: () => import ('@/asahi/stock/StockAuditIndex')
            }

        ]
    },
    /**
    * REPORT
    */
    {
        path: '/report',
        name: 'report',
        component: () => import('@/asahi/report/ReportPage'),
        children: [
            {
                path: 'income-statement-monthly-report',
                name: 'income-statement-monthly-report',
                component: () => import('@/asahi/report/IncomeStatementMonthlyReport'),
            },
            {
                path: 'receivable-customer-report',
                name: 'receivable-customer-report',
                component: () => import('@/asahi/report/ReceivableCustomerReport'),
            },
            {
                path: 'receivable-recap-report',
                name: 'receivable-recap-report',
                component: () => import('@/asahi/report/ReceivableRecapReport'),
            },
            {
                path: 'payable-supplier-report',
                name: 'payable-supplier-report',
                component: () => import('@/asahi/report/PayableSupplierReport'),
            },
            {
                path: 'payable-recap-report',
                name: 'payable-recap-report',
                component: () => import('@/asahi/report/PayableRecapReport'),
            },
            {
                path: 'sale-daily-report',
                name: 'sale-daily-report',
                component: () => import('@/asahi/report/SaleDailyReport'),
            },
            {
                path: 'sale-monthly-report',
                name: 'sale-monthly-report',
                component: () => import('@/asahi/report/SaleMonthlyReport'),
            }
        ]
    },
])
